export const PLATFORM_ID = process.env.REACT_APP_PLATFORM_ID || '';

export const CHECKOUT_URL = process.env.REACT_APP_CHECKOUT_URL || '';
